import React, { PureComponent } from 'react';
import { injectIntl, defineMessages } from 'react-intl';

import { Label, Popup } from 'semantic-ui-react';

import classNames from 'classnames/bind';
import styles from './ExamAttachList.css';
const cx = classNames.bind(styles);

// 부가 기능, 제약사항 Label
class AttachLabel extends PureComponent {
  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { type, value } = this.props;

    const returnLabel = [];
    const attachData = JSON.parse(value);
    const active = [];
    for (const key in attachData) {
      if (attachData.hasOwnProperty(key)) {
        active.push(key);

        returnLabel.push(
          <Label key={key} basic size="small" className={cx('template-type-label color-bg-' + type)}>
            {key}
          </Label>
        );
      }
    }

    return (
      <Popup
        position="left center"
        trigger={<div>{returnLabel}</div>}
        className={cx('attach-ui-popup')}
        content={
          <div className={cx('attach-popup')}>
            {type === 'attachFunction' ? (
              <div className={cx('func')}>
                <div className={cx({ brand: active.indexOf('PG') > -1 })}>
                  {defineMessages(
                    formatMessage({ id: 'ExamAttachFunc_1', defaultMessage: 'PG(PC Gather) - PC 정보 수집 기능' })
                  )}
                </div>
                <div className={cx({ brand: active.indexOf('LG') > -1 })}>
                  {defineMessages(
                    formatMessage({
                      id: 'ExamAttachFunc_2',
                      defaultMessage: 'LG(LeakFile Gather) - PC의 파일 정보 수집 기능'
                    })
                  )}
                </div>
                <div className={cx({ brand: active.indexOf('PL') > -1 })}>
                  {defineMessages(
                    formatMessage({ id: 'ExamAttachFunc_3', defaultMessage: 'PL(PC Lock) - PC 잠금(모의악성) 기능' })
                  )}
                </div>
                <div className={cx({ brand: active.indexOf('VS') > -1 })}>
                  {defineMessages(
                    formatMessage({ id: 'ExamAttachFunc_4', defaultMessage: 'VS(Vaccine Step) - 백신 단계 기능' })
                  )}
                </div>
              </div>
            ) : (
              <div className={cx('restrict')}>
                <div className={cx({ brand: active.indexOf('UAC') > -1 })}>
                  {defineMessages(
                    formatMessage({
                      id: 'ExamAttachRestrict_1',
                      defaultMessage: 'UAC(User Account Control) - Windows 사용자 계정 컨트롤 탐지 가능'
                    })
                  )}
                </div>
                <div className={cx({ brand: active.indexOf('SS') > -1 })}>
                  {defineMessages(
                    formatMessage({
                      id: 'ExamAttachRestrict_2',
                      defaultMessage: 'SS(Smart Screen) - Windows 스마트 스크린에 탐지 가능'
                    })
                  )}
                </div>
                <div className={cx({ brand: active.indexOf('SF') > -1 })}>
                  {defineMessages(
                    formatMessage({
                      id: 'ExamAttachRestrict_3',
                      defaultMessage: 'SF(Spam Filter) - 메일 스팸 필터에 탐지 가능'
                    })
                  )}
                </div>
                <div className={cx({ brand: active.indexOf('VD') > -1 })}>
                  {defineMessages(
                    formatMessage({
                      id: 'ExamAttachRestrict_4',
                      defaultMessage: 'VD(Vaccine Detect) - 백신 탐지 가능함(V3, 알약···)'
                    })
                  )}
                </div>
                <div className={cx({ brand: active.indexOf('LC') > -1 })}>
                  {defineMessages(
                    formatMessage({
                      id: 'ExamAttachRestrict_5',
                      defaultMessage: 'LC(Link Click) - 문서 안에 링크를 클릭해야 감염 처리'
                    })
                  )}
                </div>
                <div className={cx({ brand: active.indexOf('UC') > -1 })}>
                  {defineMessages(
                    formatMessage({
                      id: 'ExamAttachRestrict_6',
                      defaultMessage: 'UC(User Control) - 사용자의 동의가 필요함'
                    })
                  )}
                </div>
                <div className={cx({ brand: active.indexOf('DW') > -1 })}>
                  {defineMessages(
                    formatMessage({
                      id: 'ExamAttachRestrict_7',
                      defaultMessage: 'DW(Download Warning) - 메일에서 파일 다운로드시 경고 발생'
                    })
                  )}
                </div>
              </div>
            )}
            {/* <Image className={cx('')} src={'/img/fileext/' + value} /> */}
          </div>
        }
      />
    );
  }
}

AttachLabel.propTypes = {};
AttachLabel.defaultProps = {};

export default injectIntl(AttachLabel);



// WEBPACK FOOTER //
// ./src/script/components/examAttach/AttachLabel.js